module.exports = __webpack_public_path__ + "static/test-automation-and-devops-success-2293c7b17606227d48fe43850e9a7011.jpg";